import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Alert from '@material-ui/lab/Alert';
import { removeRecordImgError } from '@src/actions/common';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import './ActiveChat.css';

type TerrorFile = {
  maxSizeMB: number;
  file: { name: string; size: number };
  notAllowedFileMsg: string;
  compressMsg: string;
};

type Tprops = {
  activeProviderName: string;
  loadedImagesErrors: TerrorFile[];
};
// TODO include FileErrorType errors here
const AlertMaxSizeImage = ({
  activeProviderName,
  loadedImagesErrors = [],
}: Tprops) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      // eslint-disable-next-line array-callback-return
      loadedImagesErrors.map((error: { file: { name: string } }) => {
        const { file } = error;
        dispatch(removeRecordImgError(file.name));
      });
    }, 6000);
    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadedImagesErrors]);

  return (
    <>
      {!!loadedImagesErrors.length &&
        loadedImagesErrors.map((error: TerrorFile) => {
          const {
            maxSizeMB,
            file: { name },
            notAllowedFileMsg,
            compressMsg,
          } = error;

          // TODO temporal condition while add FileErrorType errors
          if (!notAllowedFileMsg && !maxSizeMB && !compressMsg) return null;

          const errorSizeMSg = (
            <FormattedMessage
              id="AgentChatTimeline.OutGoing.SendImg.ErrorSize"
              values={{
                name,
                size: maxSizeMB,
                providerName: activeProviderName,
              }}
            />
          );
          const alertMessage = maxSizeMB
            ? errorSizeMSg
            : notAllowedFileMsg || compressMsg;

          return (
            <Alert
              className="alert-img"
              key={name ?? alertMessage}
              variant="filled"
              severity="warning"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    dispatch(removeRecordImgError(name));
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {alertMessage}
            </Alert>
          );
        })}
    </>
  );
};

export default AlertMaxSizeImage;
